import React, { useEffect, useState } from 'react';
import { ArrowDownRightIcon, MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
const metrics = [['12,482', 'EXPERIENCES'], ['8,721', 'PRODUCTS CAUGHT'], ['72%', 'REDEMPTION'], ['4.6', 'EXPERIENCE SCORE']];
export function Hero() {
  const [showTurn, setShowTurn] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (reduceMotion) {
      setShowTurn(true);
      return;
    }
    const timer = window.setTimeout(() => setShowTurn(true), 1400);
    return () => window.clearTimeout(timer);
  }, [reduceMotion]);
  return <section id="top" className="poster-rules relative isolate min-h-screen overflow-hidden bg-[#f7f5ef] pt-20" aria-labelledby="hero-heading" data-id="element-427" data-mp="ncgm0kvouzwd">
      <div className="pointer-events-none absolute left-0 top-[51%] h-px w-[55%] bg-[#ff4d17]/50" data-id="element-428" data-mp="3d2birmcv0tty" />
      <div className="relative mx-auto flex min-h-[calc(100vh-5rem)] max-w-[1440px] flex-col justify-center px-5 py-16 md:px-10" data-id="element-429" data-mp="381nwfdzkt162">
        <div className="relative z-10 max-w-[1050px]" data-id="element-430" data-mp="3j6g1pzwctvil">
          <motion.p initial={reduceMotion ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-xs font-extrabold tracking-[0.16em] text-black/50" data-id="element-431" data-mp="3o6khfnpfum7r">
            THE PRODUCT EXPERIENCE PLATFORM
          </motion.p>

          <h1 id="hero-heading" className="mt-7 font-display text-[clamp(3.9rem,9.6vw,9rem)] font-bold leading-[0.83] tracking-[-0.075em]" data-id="element-432" data-mp="30gzw4y5tbcvb">
            <AnimatePresence mode="wait" data-id="element-433" data-mp="35aue9x5rrjsa">
              {showTurn ? <motion.span key="turn" initial={reduceMotion ? false : {
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1]
            }} className="block text-[#ff4d17]" data-id="element-434" data-mp="2qkwjuzh8xxun">
                  <span className="block" data-id="element-435" data-mp="2lmv16fnqg0jp">We turn</span>
                  <span className="block pl-[8vw] md:pl-[15vw]" data-id="element-436" data-mp="s2b73w324f43">
                    brands into
                  </span>
                  <span className="block" data-id="element-437" data-mp="n9qhz7v3iq6w">them.</span>
                </motion.span> : <motion.span key="interrupt" exit={{
              opacity: 0,
              y: -16
            }} transition={{
              duration: 0.28
            }} className="block" data-id="element-438" data-mp="ibgm0v1jrlk8">
                  <span className="block" data-id="element-439" data-mp="1b1fel0eya0tn">Advertising</span>
                  <span className="block pl-[5vw] md:pl-[11vw]" data-id="element-440" data-mp="1ayt7f1vz1nby">
                    interrupts
                  </span>
                  <span className="block" data-id="element-441" data-mp="112pv537eo8ba">experiences.</span>
                </motion.span>}
            </AnimatePresence>
          </h1>

          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: reduceMotion ? 0 : 0.25
        }} className="mt-10 max-w-xl" data-id="element-442" data-mp="x0306tffu79v">
            <p className="text-lg leading-relaxed text-black/65 md:text-xl" data-id="element-443" data-mp="1x9b42xkwqvaz">
              Sampler turns physical products into interactive consumer
              experiences designed to be targeted, scalable and measurable.
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-444" data-mp="268y69llgo553">
              <a href="#start" className="inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-black px-6 text-sm font-extrabold tracking-[0.03em] text-white hover:bg-black/80" data-id="element-445" data-mp="2b0fwbely4lba">
                START A CAMPAIGN <ArrowDownRightIcon size={17} data-id="element-446" data-mp="2kydscoa1rmeg" />
              </a>
              <Link to="/platform" className="inline-flex min-h-14 items-center justify-center rounded-full border border-black/25 px-6 text-sm font-bold hover:border-black" data-id="element-447" data-mp="2l0q9x0bw7uqz">
                EXPLORE THE PLATFORM
              </Link>
            </div>
            <p className="mt-7 text-xs font-bold tracking-[0.08em] text-black/45" data-id="element-448" data-mp="uniyz8tscmjs">
              REAL PRODUCTS. REAL PEOPLE. REAL EXPERIENCES. REAL FEEDBACK.
            </p>
          </motion.div>
        </div>

        <HeroPhone data-id="element-449" data-mp="4a2tfh4nx3y1" />
        <ProductObject className="right-[8%] top-[17%] hidden md:block" type="can" label="SODA" data-id="element-450" data-mp="49je886ectnp" />
        <ProductObject className="right-[4%] bottom-[19%] hidden lg:block" type="bar" label="CHOCOLATE" data-id="element-451" data-mp="3vhffoakek7kt" />
        <ProductObject className="left-[6%] bottom-[20%] hidden md:block" type="shoe" label="SNEAKER" data-id="element-452" data-mp="e7h9vgql5sqc" />
        <ProductObject className="right-[30%] top-[19%] hidden xl:block" type="burger" label="BURGER" data-id="element-453" data-mp="98e7k41zq0m2" />

        <div className="absolute right-5 top-[57%] hidden grid-cols-2 gap-2 lg:grid" data-id="element-454" data-mp="3hnxs8eoliapi">
          {metrics.map(([value, label], index) => <motion.div key={label} initial={reduceMotion ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: reduceMotion ? 0 : 0.55 + index * 0.08
        }} className="w-36 border border-black/15 bg-[#f7f5ef] p-3" data-id="element-455" data-mp="3rglq7crbakpt" data-mpi={index}>
              <p className="font-display text-2xl font-bold" data-id="element-456" data-mp="2tzmzjyt1zhcb">{value}</p>
              <p className="mt-1 text-[9px] font-extrabold tracking-[0.1em] text-black/45" data-id="element-457" data-mp="19ixa5tm1t67f">
                {label}
              </p>
            </motion.div>)}
          <p className="col-span-2 mt-1 text-right text-[8px] font-bold tracking-[0.1em] text-black/40" data-id="element-458" data-mp="1eaorren881lf">
            ILLUSTRATIVE CAMPAIGN DATA
          </p>
        </div>
      </div>
    </section>;
}
function HeroPhone() {
  const reduceMotion = useReducedMotion();
  return <motion.div initial={reduceMotion ? false : {
    opacity: 0,
    y: 44,
    rotate: 4
  }} animate={{
    opacity: 1,
    y: 0,
    rotate: 0
  }} transition={{
    duration: 0.7,
    delay: reduceMotion ? 0 : 0.35,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative z-20 mx-auto mt-12 w-[260px] rounded-t-[42px] border-[7px] border-[#11110f] bg-[#062c50] p-2 shadow-[16px_-16px_0_#ff4d17] md:absolute md:bottom-0 md:right-[11%] md:mt-0" data-id="element-459" data-mp="1sa6lm8fdq51n">
      <div className="min-h-[390px] rounded-t-[30px] bg-[#0b4272] p-4 text-white" data-id="element-460" data-mp="7vo7453nj5u5">
        <div className="mx-auto h-5 w-20 rounded-full bg-[#11110f]" data-id="element-461" data-mp="bw83v7kbc7fr" />
        <p className="mt-7 text-xs font-bold tracking-[0.12em] text-[#72c7e8]" data-id="element-462" data-mp="2egivmh7i8si9">
          GONE FISHING
        </p>
        <p className="mt-2 font-display text-3xl font-bold leading-none" data-id="element-463" data-mp="29izdv7bllxlk">
          Something big is swimming nearby.
        </p>
        <div className="mt-8 flex h-44 items-center justify-center rounded-[24px] border border-[#72c7e8]/40 water-lines" data-id="element-464" data-mp="24pefvfa093md">
          <motion.span animate={reduceMotion ? undefined : {
          y: [-6, 6, -6]
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="grid h-14 w-14 place-items-center rounded-full bg-[#ff4d17]" data-id="element-465" data-mp="1vrlxg28zlfur">
            <MapPinIcon size={24} data-id="element-466" data-mp="1lteskhrz2o94" />
          </motion.span>
        </div>
        <div className="mt-5 flex items-center justify-between text-xs" data-id="element-467" data-mp="1guv7skp47iic">
          <span data-id="element-468" data-mp="3g6nv1pm3p9hv">2.4 KM AWAY</span>
          <span className="rounded-full bg-[#72c7e8] px-2 py-1 font-bold text-[#062c50]" data-id="element-469" data-mp="3g5mkdm8zyp0o">
            CAST
          </span>
        </div>
      </div>
    </motion.div>;
}
function ProductObject({
  className,
  type,
  label
}: {
  className: string;
  type: 'can' | 'bar' | 'shoe' | 'burger';
  label: string;
}) {
  const reduceMotion = useReducedMotion();
  const shapes = {
    can: 'h-24 w-12 rounded-[14px] border-4 border-black bg-[#ff4d17]',
    bar: 'h-12 w-28 rounded-sm border-4 border-black bg-[#f3c64b]',
    shoe: 'h-14 w-28 rounded-[60%_20%_30%_15%] border-4 border-black bg-white',
    burger: 'h-16 w-20 rounded-[50%_50%_28%_28%] border-4 border-black bg-[#f3c64b]'
  };
  return <motion.div animate={reduceMotion ? undefined : {
    y: [0, -11, 0],
    rotate: [-4, 4, -4]
  }} transition={{
    duration: 4.5,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`absolute z-10 ${className}`} data-id="element-470" data-mp="34sm7i4wg6qun">
      <div className={`${shapes[type]} shadow-[7px_7px_0_#11110f]`} data-id="element-471" data-mp="3erbntt8p438s" />
      <p className="mt-3 text-center text-[9px] font-extrabold tracking-[0.14em] text-black/55" data-id="element-472" data-mp="ozdh6n6uvlfk">
        {label}
      </p>
    </motion.div>;
}